import { useContext } from 'react';

import AttributeDetails from '@atom/components/common/attributeDetails/AttributeDetails';
import { AttributeView } from '@atom/components/common/attributeDetails/AttributeDetailsContext';
import SchemaDetailContext from '@atom/components/schemaDetail/SchemaDetailContext';
import { SchemaTree } from '@atom/types/schema';

import { hydrateAttributesWithPendingChanges } from '../schemaPreviewUtilities';

interface Props {
  schema: Partial<SchemaTree>;
}

const PreviewAttributeDetails = ({ schema }: Props) => {
  const { pendingUpdates, pendingCreations } = useContext(SchemaDetailContext);

  const mappedSchema = {
    ...schema,
    attributeGroups: schema.attributeGroups.map(attributeGroup => {
      return {
        ...attributeGroup,
        attributes: hydrateAttributesWithPendingChanges(
          schema.id,
          attributeGroup.id,
          attributeGroup.attributes,
          pendingUpdates,
          pendingCreations,
        ),
      };
    }),
  };

  return (
    <AttributeDetails
      onPendingApproval={() => {}}
      // @ts-ignore
      asset={mappedSchema}
      onAttributeUpdate={() => {}}
      loading={[]}
      canManageChanges
      canUpdate
      skipManualAttributeValidation
      view={AttributeView.SCHEMA_PREVIEW}
      inputWidth="25vw"
    />
  );
};

export default PreviewAttributeDetails;
